import React, { useContext, useEffect, useState } from 'react';
import { store } from '../reducer';
import axios from '../../../../../api/axios';
import { makeStyles } from '@material-ui/core/styles';
import DataGrid from '../../../../../components/DataGrid/DataGrid';
import moment from 'moment-jalaali';
import Avatar from '../../../../../components/User/UserAvatar';
import { Link, useHistory } from 'react-router-dom';
import { __ } from '../../../../../utils/i18n';
import { localText } from '../../../../../langs/fa/data-grid';
import DatePicker from '../../../../../components/TextFields/DatePicker';
import useTitle from 'hooks/useTitle';
import { isMobile } from 'react-device-detect';
import { formatNumber } from 'fns';
import Total from 'components/Total/Total';
import { toFA } from 'fns/toFA';
import { toEN } from 'fns';
import { rond } from 'fns';
import { useQuery } from 'react-query';
import CanceledFilters from './Filters';
import FullCard from 'components/Card/FullCard';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    width: '100%',
    '& .cancelList': {
      height: !isMobile ? 480 : '',
    },
    '& .pending': {
      background: '#ffecb3',
    },
    '& .tendering': {
      background: '#e6ee9c',
    },
    '& .getWaybill': {
      background: '#bbdefb',
    },
    '& .rejected': {
      background: '#e0e0e0',
    },
    '& .loadTime': {
      fontSize: 12,
    },
    '& .colHeader': {
      background: '#607d8b',
      color: '#fff',
    },
  },
  fleetCount: {
    '& > span.red': {
      background: '#dd2c00',
      color: '#fff',
      padding: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    '& > span.green': {
      background: '#76ff03',
      padding: theme.spacing(1),
    },
  },
}));

const Cancels = () => {
  useTitle('گزارش سفارش های کنسل شده');
  const classes = useStyles();
  const {
    state,
    dispatch,
    showMessage,
    showError,
    itemsCountPerPage,
  } = useContext(store);
  const [totalDocs, setTotalDocs] = useState(0);
  const columns = [
    {
      field: 'rowNumber',
      headerName: 'ردیف',
      width: 100,
      renderCell: ({ value }) => value,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'loadingDate',
      headerName: 'بارگیری',
      width: 100,
      renderCell: ({ value }) => moment(value.loadDate).format('jYY/jMM/jDD'),
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'customer',
      headerName: 'صاحب‌بار',
      flex: 1,
      renderCell: ({ value: { customer } }) => (
        <Avatar user={customer} fullName width={30} height={30} />
      ),
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'origin',
      headerName: 'مبدا',
      width: 100,
      renderCell: ({ value: { origin } }) => origin.title,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'fleetOptions',
      headerName: 'ناوگان',
      flex: 1,
      renderCell: ({ value: { fleetOptions } }) =>
        fleetOptions.map((f) => `${f.fleet.title}(${f.title})`).join('، '),
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'fleetCount',
      headerName: 'تعداد ناوگان',
      width: 130,
      renderCell: ({ value: { _id, fleetCount, drivers } }) => {
        if (fleetCount === 1)
          return <Link to={`/protected/admin/orders/${_id}#fleets`}>1</Link>;
        else
          return (
            <Link to={`/protected/admin/orders/${_id}#fleets`}>
              <div className={classes.fleetCount}>
                <span className="red">مانده:{fleetCount - drivers.length}</span>
                <span className="green">آماده:{drivers.length}</span>
              </div>
            </Link>
          );
      },
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'destination',
      headerName: 'مقصد',
      width: 100,
      renderCell: ({ value: { destination } }) => destination.title,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    // {
    //   field: 'loadingTime',
    //   headerName: 'زمان‌بارگیری',
    //   width: 120,
    //   renderCell: ({ value: { loadTime } }) => __(loadTime),
    //   cellClassName: ({ value: { status } }) => `${status} loadTime`,
    //   headerClassName: 'colHeader',
    // },
    {
      field: 'commission',
      headerName: 'کارمزد شرکت',
      width: 120,
      renderCell: ({ value }) => formatNumber(value || 0),
      cellClassName: ({ value }) => `commission`,
      headerClassName: 'colHeader',
    },
    {
      field: 'loadType',
      headerName: 'محموله',
      width: 100,
      renderCell: ({ value: { cargos } }) => cargos?.[0]?.type?.title,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    // {
    //   field: 'packaging',
    //   headerName: 'بسته‌بندی',
    //   width: 100,
    //   renderCell: ({ value: { cargos } }) => cargos?.[0]?.packaging?.title,
    //   cellClassName: ({ value: { status } }) => status,
    //   headerClassName: 'colHeader',
    // },
    {
      field: 'status',
      headerName: 'وضعیت',
      width: 100,
      renderCell: ({ value: { status } }) => __(status),
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
  ];
  const [values, setValues] = useState({
    page: 1,
    orders: null,
    loading: false,
    fromDate: moment(),
    toDate: moment(),
    selectedUser: null,
  });
  const [totalOrder, setTotalOrder] = useState(0);
  const { page, loading, orders, fromDate, toDate, selectedUser } = values;
  const history = useHistory();

  const handlePageChange = async (page) => {
    setValues({ ...values, page: page + 1 });
  };
  const handleSelectOrder = ({ row, field }) => {
    const { id } = row;
    const fields = ['customer', 'fleetCount'];
    if (fields.includes(field)) return;
    history.push(`/protected/admin/orders/${id}`);
  };

  function handleRowsNumber(index, limit, page) {
    return index + 1 + page * 1 * limit * 1 - limit * 1;
  }
  function totalCompanyCommission() {
    setTotalOrder(0);
    data.canceled.docs.map((order) =>
      setTotalOrder(
        (prev) => prev + (order.commission ? order.commission : 0) * 1
      )
    );
  }
  const loadCancels = async (signal) => {
    try {
      setValues({ ...values, loading: true });
      const { data } = await axios.post(
        `/api/v1/admin/reports/canceled`,
        {
          page,
          limit: itemsCountPerPage,
          fromDate,
          toDate,
          customer: selectedUser?._id || null,
        },
        {
          signal,
        }
      );
      setTotalDocs(data.canceled.totalDocs);
      return data;
      setValues({ ...values, orders: data?.canceled, loading: false });
    } catch (error) {
      if (error?.message === 'canceled') {
        return;
      }
      showError(error);
    }
  };

  useEffect(() => {
    dispatch({
      type: 'CHANGE_TITLE_CATEGORY',
      payload: {
        title: 'گزارش سفارش‌های کنسل شده',
        category: 'گزارش سفارشاتی که در روز جاری کنسل شده اند',
      },
    });
  }, []);
  // useEffect(() => {
  //   loadCancels();
  // }, [fromDate, toDate, page]);

  const { data, isLoading } = useQuery(
    ['loadCancelsOrders', fromDate, toDate, page, selectedUser],
    ({ signal }) => loadCancels(signal),
    {
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    data?.canceled?.docs?.length > 0 &&
      data?.canceled?.page === page &&
      totalCompanyCommission();

    return () => setTotalOrder(0);
  }, [
    data?.canceled?.docs?.length,
    page,
    data?.canceled?.page,
    fromDate,
    toDate,
    selectedUser,
  ]);

  return (
    <div className={classes.root}>
      <FullCard className={'pt-1'} divider={false}>
        <CanceledFilters
          fromDate={fromDate}
          toDate={toDate}
          totalCompanyCommission={totalCompanyCommission}
          setValues={setValues}
          values={values}
          totalOrder={totalOrder}
        />
        <div className="cancelList">
          <DataGrid
            rows={
              data?.canceled?.docs.length
                ? data.canceled.docs.map((order, i) => ({
                    id: order._id,
                    rowNumber: handleRowsNumber(i, itemsCountPerPage, page),
                    commission: order.commission,
                    loadingDate: order,
                    customer: order,
                    origin: order,
                    fleetOptions: order,
                    fleetCount: order,
                    destination: order,
                    loadingTime: order,
                    loadType: order,
                    packaging: order,
                    status: order,
                  }))
                : []
            }
            columns={columns}
            localeText={localText}
            pageSize={itemsCountPerPage}
            rowCount={totalDocs}
            paginationMode="server"
            onPageChange={handlePageChange}
            loading={isLoading}
            disableMultipleSelection
            onCellClick={handleSelectOrder}
            density="compact"
            // onSelectionChange={handleSelectOrder}
          />
        </div>
      </FullCard>
    </div>
  );
};

export default Cancels;
